<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18IGzZN/tc-custom/cover.jpg?1684514593976?1702530658302" alt="This image is the cover for the book Montpelier Chronicles, American Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Montpelier Chronicles, American Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p>Four years after the American Revolution, in 1787, Colonel Jacob Davis became the first to clear land in the new settlement that had been chartered as Montpelier. The name honored France for its support of the American patriots. Disasters, industries and larger-than-life personalities helped shape the city's identity. And it didn't take long for Montpelier to make a name for itself--its location created a prime manufacturing hub, and the Vermont Central Railroad made travel convenient. The city also became the scene of the fire of 1875 and the Gould-Caswell murder. Join local historian Paul Heller as he compiles significant moments of Montpelier's past.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Heller
      </h2>
      
      <p class="authorDescription body article">Paul Heller came to Montpelier as a boy, attended local schools and was graduated from Montpelier High School in 1966. After graduating from Lyndon State College and Southern Connecticut State University he worked as a librarian at Norwich University for many years. That is where he first developed an interest in local history. He is a member of the Vermont Historical Society and a former member of the board of the Barre Historical Society. His published works include Granite City Tales, More Granite City Tales, The Calais Calamity, The History of the Banjo as well as numerous newspaper and magazine articles. Paul and Marianne Kotch ran a bed and breakfast in Barre, Vermont, for several years. They are now both retired and enjoy pursuing their creative interests. Paul and Marianne live in Barre, Vermont.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9b13c452